import { render, staticRenderFns } from "./DeleteProjectButton.vue?vue&type=template&id=30e45c9d&"
import script from "./DeleteProjectButton.vue?vue&type=script&lang=js&"
export * from "./DeleteProjectButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports